import classnames from "classnames";
import { twMerge } from "tailwind-merge";

const cn = (...inputs) => {
  return twMerge(classnames(inputs));
};

export default cn;
